import { useApp } from '@/context/AppContext';
import Toast from '@/components/ui/Toast';
import Modal from '@/components/ui/Modal';
import SyncIndicator from '@/components/ui/SyncIndicator';
import UserMenu from '@/components/ui/UserMenu';
import Dashboard  from '@/screens/desktop/Dashboard';
import Jobs       from '@/screens/desktop/Jobs';
import Bids       from '@/screens/desktop/Bids';
import TimeCards  from '@/screens/desktop/TimeCards';
import Team       from '@/screens/desktop/Team';
import Customers  from '@/screens/desktop/Customers';
import Billing    from '@/screens/desktop/Billing';
import Reports    from '@/screens/desktop/Reports';
import Settings   from '@/screens/desktop/Settings';

const NAV_ITEMS = [
  { id: 'dashboard',  icon: '📊', label: 'Dashboard'   },
  { id: 'jobs',       icon: '🏗️', label: 'Jobs'        },
  { id: 'bids',       icon: '📋', label: 'Bids'        },
  { id: 'time-cards', icon: '⏱️', label: 'Time Cards'  },
  { id: 'team',       icon: '👥', label: 'Team'        },
  { id: 'customers',  icon: '🏢', label: 'Customers'   },
  { id: 'invoices',   icon: '💳', label: 'Invoices'    },
  { id: 'reports',    icon: '📈', label: 'Reports'     },
  { id: 'settings',   icon: '⚙️', label: 'Settings'    },
];

const SCREEN_MAP = {
  dashboard:    Dashboard,
  jobs:         Jobs,
  bids:         Bids,
  'time-cards': TimeCards,
  team:         Team,
  customers:    Customers,
  invoices:     Billing,
  reports:      Reports,
  settings:     Settings,
};

const SIDEBAR_GROUPS = [
  { label: 'Shop Floor', ids: ['dashboard', 'jobs', 'time-cards'] },
  { label: 'Business',   ids: ['bids', 'customers', 'invoices', 'team'] },
  { label: 'Admin',      ids: ['reports', 'settings'] },
];

export default function DesktopLayout() {
  const { screen, setScreen, stats, setForceView } = useApp();

  function getBadge(id) {
    if (id === 'jobs'       && stats.activeJobs > 0)   return stats.activeJobs;
    if (id === 'bids'       && stats.pendingBids > 0)  return stats.pendingBids;
    if (id === 'customers'  && stats.overdueCount > 0) return stats.overdueCount;
    return null;
  }

  const CurrentScreen = SCREEN_MAP[screen] || Dashboard;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Topbar */}
      <div className="topbar">
        <button className="wordmark" onClick={() => setScreen('dashboard')} style={{ border: 'none', background: 'transparent', padding: 0 }}>
          <div className="wmark">S</div>
          SteelOps
        </button>

        <nav className="topnav">
          {NAV_ITEMS.slice(0, 5).map(n => (
            <button
              key={n.id}
              className={`tnb${screen === n.id ? ' active' : ''}`}
              onClick={() => setScreen(n.id)}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="topright">
          <SyncIndicator />
          <button className="view-toggle" onClick={() => setForceView('mobile')}>
            📱 Mobile
          </button>
          <UserMenu initials="SO" />
        </div>
      </div>

      {/* Body */}
      <div className="app-body">
        {/* Sidebar */}
        <nav className="sidebar">
          {SIDEBAR_GROUPS.map(group => (
            <div key={group.label}>
              <div className="slabel">{group.label}</div>
              {group.ids.map(id => {
                const n = NAV_ITEMS.find(x => x.id === id);
                if (!n) return null;
                const badge = getBadge(id);
                return (
                  <button
                    key={id}
                    className={`si${screen === id ? ' active' : ''}`}
                    onClick={() => setScreen(id)}
                  >
                    <span className="ico">{n.icon}</span>
                    {n.label}
                    {badge != null && (
                      <span
                        className="badge"
                        style={{
                          background: id === 'customers' ? 'var(--rose-t)' : 'var(--amber-t)',
                          color:      id === 'customers' ? 'var(--rose)'   : 'var(--amber)',
                        }}
                      >
                        {badge}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          ))}
        </nav>

        {/* Main content */}
        <main className="main">
          <CurrentScreen />
        </main>
      </div>

      <Modal />
      <Toast />
    </div>
  );
}
